import { StepFunctionTaskRequestSchema } from '../request.js';
import { PhotoReportInputSchema } from './photoReportInput.js';
export const BuildPhotoReportInputSchema = PhotoReportInputSchema;
export const BuildPhotoReportRequestSchema = StepFunctionTaskRequestSchema.extend({
    input: BuildPhotoReportInputSchema,
});
